import {IconButton, InputAdornment} from '@material-ui/core';
import {ClassNameMap} from '@material-ui/styles/withStyles/withStyles';
import clsx from 'clsx';
import React from 'react';
import {ReactComponent as ChevronIconDown} from '../icons/icon-chevron-down.svg';
import {ReactComponent as ChevronIconUp} from '../icons/icon-chevron-up.svg';
import styles from './InputEndAdornment.scss';

interface Props {
  canDecrement: boolean;
  canIncrement: boolean;
  endAdornment: React.ReactNode;
  updateValue: (multiplier: number) => void;
  disabled: boolean;
  showArrows: boolean;
}

export const InputEndAdornment = (
    {disabled, canDecrement,  canIncrement, endAdornment, updateValue, showArrows}: Props
  ): React.ReactElement => {

  const handleMouseDownOnIcons = (event: React.MouseEvent<HTMLButtonElement>): void => event.preventDefault();

  const getArrowClasses = (canUpdateValue: boolean): Partial<ClassNameMap> => ({
    root: clsx(
      styles.arrow,
      {
        [styles.arrow_hidden]: disabled,
        [styles.arrow_limitReached]: !canUpdateValue
      }
    )
  });

  return (
    <InputAdornment className={styles.inputAdornment} position='end'>
      {
        showArrows && (
          <div className={styles.arrowsWrapper}>
            <IconButton onClick={(): void => updateValue(1)}
                        classes={getArrowClasses(canIncrement)}
                        onMouseDown={handleMouseDownOnIcons}
                        disabled={disabled || !canIncrement}
                        aria-label='increment value'>
              <ChevronIconUp/>
            </IconButton>
            <IconButton onClick={(): void => updateValue(-1)}
                        classes={getArrowClasses(canDecrement)}
                        onMouseDown={handleMouseDownOnIcons}
                        disabled={disabled || !canDecrement}
                        aria-label='decrement value'>
              <ChevronIconDown/>
            </IconButton>
          </div>
        )
      }
      {
        endAdornment && <div className={styles.endAdornment}>{endAdornment}</div>
      }
    </InputAdornment>
  );
};